// src/blogs/FloatingMiniHead.jsx
// Small always-on-top head, pinned top-left on every blog scene, tilted to
// match the scene you're currently in. Click it to fly back to the head scene.
import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";

import { Head } from "./HeadModel.jsx";
import { HEAD_SIZE } from "./headModelUtils.js";

const MINI_SIZE = HEAD_SIZE * 0.55;

export default function FloatingMiniHead({ target = { yaw: 0, pitch: 0 }, onSelect }) {
  return (
    <div className="floating-mini-head" aria-hidden={false}>
      <Canvas
        dpr={[1, 1.75]}
        gl={{ antialias: true, alpha: true }}
        camera={{ fov: 40, near: 0.1, far: 20, position: [0, 0, 4.4] }}
      >
        <ambientLight intensity={0.5} color="#ffffff" />
        <directionalLight position={[5, 10, 2]} intensity={5} color="#f2feff" />
        <directionalLight position={[-4, -1, 3]} intensity={1.1} color="#eef4ff" />

        <Suspense fallback={null}>
          <Head yaw={target.yaw} pitch={target.pitch} size={MINI_SIZE} onSelect={onSelect} />
        </Suspense>
      </Canvas>
    </div>
  );
}
